import axios from 'axios'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import appConfig from '../config'
import { fetchLiveSessions, setLiveSessions } from '../slices/sessionSlice'

const useLiveSessions = (params?: string) => {
  const dispatch = useDispatch()
  const { liveSessions, isLoading, hasFetched } = useSelector(
    (state: any) => state.liveSessions
  )
  const { currentUser } = useSelector((state: any) => state.auth)

  useEffect(() => {
    if (!currentUser) return

    dispatch(fetchLiveSessions())
    axios.get(`${appConfig.API_URL}/live_sessions`).then(({ status, data }) => {
      if (status === 200) {
        dispatch(setLiveSessions(data.live_sessions))
      }
    })
  }, [currentUser])

  return { liveSessions, isLoading }
}

export { useLiveSessions }
